import * as React from 'react';
import * as I18n from 'i18n-js';
import bind from '@reverbdotcom/commons/dist/bind';
import { V3 } from './api_request';

interface IProps {
  paymentMethod: string;
  postURL: string;
  showAffirmWarning: boolean;
  checkoutUUID: string;
}

interface IState {
  code: string;
  error: string;
  disabled: boolean;
}

export default class PromoCodeRedemptionForm extends React.Component<IProps, IState> {
  state = {
    code: '',
    error: '',
    disabled: false,
  };

  @bind
  updateCode(evt) {
    this.setState({ code: evt.target.value });
  }

  @bind
  onSubmit(evt) {
    evt.preventDefault();
    this.setState({ disabled: true });

    return V3.postJSON(
      this.props.postURL,
      {
        discount_code: this.state.code,
        payment_method: this.props.paymentMethod,
        checkout_uuid: this.props.checkoutUUID,
      },
    ).then((res) => {
      if (res.redirect) {
        window.location = res.redirect;
      } else {
        this.handleError(res);
      }
    }).fail(this.handleError);
  }

  @bind
  handleError(res) {
    const error = res.message || I18n.t('discovery.promoCodeRedemptionForm.genericError');
    this.setState({
      error,
      disabled: false,
    });
  }

  submitValue(disabled) {
    if (disabled) {
      return I18n.t('discovery.wait');
    }

    return I18n.t('discovery.promoCodeRedemptionForm.submit');
  }

  renderAffirmWarning() {
    if (!this.props.showAffirmWarning) return null;

    return (
      <h4 className="mt-space" data-affirm-warning>
        {I18n.t('discovery.promoCodeRedemptionForm.affirmWarning')}
      </h4>
    );
  }

  render() {
    return (
      <div className="module">
        <h3 className="heading-3 mb-1">
          {I18n.t('discovery.promoCodeRedemptionForm.header')}
        </h3>
        <div className="mb-1" data-promo-code-error>
          {this.state.error}
        </div>
        <form onSubmit={this.onSubmit}>
          <div className="g-container">
            <div className="g-col-9">
              <input
                type="text"
                name="discount_code"
                id="discount_code"
                placeholder={I18n.t('discovery.promoCodeRedemptionForm.placeholder')}
                className="checkout-coupon-code wide"
                value={this.state.code}
                onChange={this.updateCode}
              />
              {this.renderAffirmWarning()}
            </div>
            <div className="g-col-3">
              <input
                type="submit"
                className="btn btn-blue wide"
                value={this.submitValue(this.state.disabled)}
                disabled={this.state.disabled}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/promo_code_redemption_form.tsx